<template>
  <div class="introduce">
    <div class="introduce-content">
      <div class="title-56">{{ $t('keypalTwo.introduce.title') }}</div>
      <div class="desc-18">{{ $t('keypalTwo.introduce.desc_1') }}</div>
      <div class="box-wrap">
        <!-- hidden-scrollbar -->
        <div class="column-1">
          <Card1 @openVideo="showVideo" />
          <Card4 @openVideo="showVideo" />
          <!-- <Card1 class="fixed-card-1" :class="{ show: currentIndex === 1 }" />
          <Card4 class="fixed-card-4" v-if="currentIndex === 4" /> -->
        </div>
        <div class="column-2">
          <Card2 @openVideo="showVideo" />
          <Card5 @openVideo="showVideo" />
        </div>
        <div class="column-3">
          <Card3 @openVideo="showVideo" />
          <Card6 @openVideo="showVideo" />
        </div>
        <PopupVideoBox class="fixed-card" v-if="currentIndex" :class="[`fixed-card-${currentIndex}`]" :index="currentIndex" />
      </div>
      <div class="mobile-box-wrap hidden-scrollbar">
        <Card1 @openVideo="showVideo" />
        <Card2 @openVideo="showVideo" />
        <Card3 @openVideo="showVideo" />
        <Card4 @openVideo="showVideo" />
        <Card5 @openVideo="showVideo" />
        <Card6 @openVideo="showVideo" />
      </div>
    </div>
  </div>
</template>

<script>
import Card1 from '../card/Card1.vue';
import Card2 from '../card/Card2.vue';
import Card3 from '../card/Card3.vue';
import Card4 from '../card/Card4.vue';
import Card5 from '../card/Card5.vue';
import Card6 from '../card/Card6.vue';
import PopupVideoBox from './PopupVideoBox.vue';

import Overlay from "../../utils/overlay";
import { mapGetters } from 'vuex';

export default {
  components: {
    Card1,
    Card2,
    Card3,
    Card4,
    Card5,
    Card6,
    PopupVideoBox,
  },
  data() {
    return {
      currentIndex: null,
      videoTimeout: null,
    };
  },
  computed: {
    ...mapGetters(['isMobileSize']),
    img1() {
      return require('../../assets/images/keypal-two/introduce-1.png');
    },
    img2() {
      return require('../../assets/images/keypal-two/introduce-2.png');
    },
    img3() {
      return require('../../assets/images/keypal-two/introduce-3.png');
    },
    img4() {
      return require('../../assets/images/keypal-two/introduce-4.png');
    },
    img5() {
      return require('../../assets/images/keypal-two/introduce-5.png');
    },
    img6() {
      return require('../../assets/images/keypal-two/introduce-6.png');
    },
    addIcon() {
      return require('../../assets/images/keypal-two/add-1.png');
    },
    addIcon2() {
      return require('../../assets/images/keypal-two/add-2.png');
    },
  },
  beforeDestroy() {
    if (this.videoTimeout) {
      clearTimeout(this.videoTimeout);
    }
  },
  methods: {
    showVideo(index) {
      if (this.isMobileSize) {
        this.$emit('openVideo', index)
        return;
      }
      if (this.videoTimeout) {
        clearTimeout(this.videoTimeout);
        this.videoTimeout = null;
      }
      this.currentIndex = index;

      // 创建遮罩实例
      const overlay = Overlay.create({
        opacity: 0.6,         // 背景透明度
        duration: 300,        // 动画时间
        clickToClose: true,   // 点击遮罩自动关闭
        lockScroll: true,     // 使用阻止滚动事件锁定滚动
        onClick: () => {
          console.log('遮罩被点击')
          this.currentIndex = null;
        }
      });
      overlay.show();

      this.$nextTick(() => {
        const popup = document.querySelector('.popup-video');
        if (!popup) {
          return;
        }
        // popup.style.opacity = '1';
        // popup.style.transition = 'opacity 1s';
        setTimeout(() => {
          popup.classList.add('show');
        }, 10);
      })

      this.$emit('goPosition', '.box-wrap')
      this.videoTimeout = setTimeout(() => {
        // this.$emit('openVideo', index)
        // this.currentIndex = null;
      }, 0.1 * 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.introduce {
  background: var(--bg-3);
  padding: 48px 0 158px;

  .introduce-content {
    max-width: 1200px;
    margin: 0 auto;

    .desc-18 {
      margin-top: 30px;
    }

    .box {
      position: relative;
      background: var(--bg-4);
      border-radius: 32px;
      cursor: pointer;

      .add-icon {
        position: absolute;
        width: 36px;
        height: 36px;
        right: 20px;
        bottom: 20px;
      }

      .title {
        font-size: 20px;
        color: var(--color-3);
        position: absolute;
        left: 32px;
        top: 32px;
      }

      .desc {
        font-size: 32px;
        font-weight: 600;
        color: var(--color-1);
        position: absolute;
        top: 73px;
        padding: 0 32px;
      }
    }

    .box-wrap {
      position: relative;
      // margin-top: 50px;
      // max-width: 1200px;
      margin-top: 0.5rem;
      max-width: 12rem;
      overflow: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0 24px;

      .fixed-card {
        position: absolute;
        z-index: -1;
        opacity: 0;
        margin: 0;
        // padding: 0;
        background: var(--bg-2);
        visibility: visible;
        border-radius: 32px;
        &.show {
          // visibility: hidden;
          // transition: opacity 0.3s linear, width 0.3s linear, height 0.3s linear, visibility 0s linear 0.3s;
          transition: opacity 0.2s linear, width 0.2s linear, height 0.2s linear;
          z-index: 9999;
          opacity: 1;
          width: 100%;
          height: 100%;
        }
      }

      .fixed-card-1 {
        width: 384px;
        height: 500px;
        width: 3.84rem;
        height: 5rem;
        top: 0;
        left: 0;
        transform-origin: left top;
      }

      .fixed-card-2 {
        width: 384px;
        height: 500px;
        width: 3.84rem;
        height: 5rem;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        transform-origin: center top;
        &.show {
          left: 50%;
          transform: translateX(-50%) scale(1);
        }
      }

      .fixed-card-3 {
        width: 384px;
        height: 417px;
        width: 3.84rem;
        height: 4.17rem;
        top: 0;
        right: 0;
        left: auto;
        transform-origin: right top;
      }

      .fixed-card-4 {
        width: 384px;
        height: 213px;
        width: 3.84rem;
        height: 2.13rem;
        left: 0;
        bottom: 0;
        transform-origin: left bottom;
      }

      .fixed-card-5 {
        width: 384px;
        height: 213px;
        width: 3.84rem;
        height: 2.13rem;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        transform-origin: center bottom;
        &.show {
          left: 50%;
          transform: translateX(-50%) scale(1);
        }
      }

      .fixed-card-6 {
        width: 384px;
        height: 286px;
        width: 3.84rem;
        height: 2.86rem;
        bottom: 0;
        right: 0;
        transform-origin: right bottom;
      }

      .column-1 {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 14px 0;
      }

      .column-2 {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 14px 0;
      }

      .column-3 {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px 0;
      }
    }

    .mobile-box-wrap {
      display: none;
    }
  }
}

@media screen and (max-width: 1450px) {
  .introduce {
    .introduce-content {
      .title-56 {
        font-size: 27px;
      }

      .box-wrap {
        .fixed-card {
          &.show {
            width: calc(100% - 30px);
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 90%;
            height: 90%;
          }
        }
      }
    }
  }
}

// @media screen and (max-width: 1200px) {
//   .introduce {
//     .introduce-content {
//       .box-wrap {
//         .fixed-card {
//           &.show {
//             width: calc(100% - 30px);
//             left: 50%;
//             top: 50%;
//             transform: translate(-50%, -50%);
//           }
//         }
//       }
//     }
//   }
// }

@media screen and (max-width: 767px) {
  .introduce {
    padding: 64px 0 96px;
    .introduce-content {
      .title-56 {
        padding: 0 28px;
      }
      .desc-18 {
        margin-top: 16px;
        font-size: 16px;
      }

      .box {
        min-width: 276px;
        font-size: 0;
        border-radius: 23px;
        .title {
          font-size: 15px;
          left: 23px;
          top: 23px;
        }

        .desc {
          font-size: 23px;
          top: 53px;
          padding: 0 23px;
        }

        .add-icon {
          width: 26px;
          height: 26px;
          right: 15px;
          bottom: 15px;
        }
      }

      .box-wrap {
        display: none;
      }

      .mobile-box-wrap {
        margin-top: 32px;
        display: flex;
        gap: 0 16px;
        overflow: auto;
        padding: 0 28px;
      }
    }
  }
}
</style>
